<template>
	<div id="lib">
		<keep-alive>
      <a-config-provider :locale="locale">
        <router-view />
      </a-config-provider>
		</keep-alive>
	</div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
	name: 'Lib',
	mounted() {
	},
	created() {
	},
	data() {
		return {
      locale: zhCN,
    };
	}
}
</script>

<style>
@import 'http://at.alicdn.com/t/font_2264565_bdt1pz28pav.css';

#lib {
	height: 100%;
}

.ant-pagination a {
	margin-left: 0 !important;
}
</style>
